import { useContext } from 'react';
import { Dispatch, SetStateAction } from 'react';
import { Client, Context as UrqlContext } from 'urql';
import {
  GetCompatibleDocument,
  GetCompatibleQuery,
  GetCompatibleQueryVariables,
} from 'views/utils/graphql/graphql';
import { ITExplanationModalStep } from '../hooks';
import { SymbolPageStep } from '../../../hooks';
import { InputMeetingDateTimeProps } from '../ItDisclosureApplicationDateSelection/hooks';
import { useGlobalLoadingHandler } from 'views/mutual/globalLoading/hook';

type useConfirmationType = {
  onClosed: (nextSymbolPageStep: SymbolPageStep, meetingDateTime?: Partial<InputMeetingDateTimeProps>) => void;
  setModalStep: Dispatch<SetStateAction<ITExplanationModalStep>>;
};

export const useConfirmation = ({ onClosed, setModalStep }: useConfirmationType) => {
  const { showLoading, hideLoading } = useGlobalLoadingHandler();
  const client = useContext(UrqlContext) as Client;
  const confirmationProps = {
    onClick: async () => {
      showLoading();
      // 適合性チェックが済んでいない場合は適合性チェックを表示する
      const compatibleRes = await client.query<GetCompatibleQuery, GetCompatibleQueryVariables>(
        GetCompatibleDocument,
        {},
        {
          requestPolicy: 'network-only',
        },
      );
      hideLoading();

      if (!compatibleRes.data?.GetAccountInfo?.Compatible?.DomesticRealEstate) {
        onClosed(SymbolPageStep.CompatibilityCheck);
        return;
      }

      setModalStep(ITExplanationModalStep.ELECTRONIC_DELIVERY_OF_DISCLOSURE_DOCUMENT);
    },
  };

  return {
    confirmationProps,
  };
};
